import Papa from "papaparse";
import { get } from "lodash";
import makeCSV from "@irati/utils/csv/makeCSV";
import adminTracking from "@irati-tracking/admin";
var generateCSV = function (rewardOrders, formatMessage, formatDate) {
    var headers = [
        formatMessage({ id: "admin.reporting.rewardOrders.orderId" }),
        formatMessage({ id: "admin.reporting.rewardOrders.senderFirstname" }),
        formatMessage({ id: "admin.reporting.rewardOrders.senderLastname" }),
        formatMessage({ id: "admin.reporting.rewardOrders.senderEmail" }),
        formatMessage({ id: "admin.reporting.rewardOrders.receiversFirstname" }),
        formatMessage({ id: "admin.reporting.rewardOrders.receiversLastname" }),
        formatMessage({ id: "admin.reporting.rewardOrders.receiversEmail" }),
        formatMessage({ id: "admin.reporting.rewardOrders.rewardName" }),
        formatMessage({ id: "admin.reporting.rewardOrders.quantity" }),
        formatMessage({ id: "admin.reporting.rewardOrders.totalCost" }),
        formatMessage({ id: "admin.reporting.rewardOrders.purchaseDate" })
    ];
    var data = rewardOrders.map(function (result) {
        var date = get(result, "createdAt");
        var purchaseDate = date ? formatDate(date, { day: "numeric", month: "numeric", year: "numeric" }) : "";
        var rewardName = get(result, "reward.header") || get(result, "custom");
        var recipientEmails = [];
        var recipientFirstnames = [];
        var recipientLastnames = [];
        result.recipients.results.map(function (user) {
            if (user.email) {
                recipientEmails.push(user.email);
                recipientFirstnames.push(user.firstname);
                recipientLastnames.push(user.lastname);
            }
        });
        var emails = "" + recipientEmails.join("\n");
        var firstnames = "" + recipientFirstnames.join("\n");
        var lastnames = "" + recipientLastnames.join("\n");
        return [
            get(result, "uuid"),
            get(result, "createdBy.firstname"),
            get(result, "createdBy.lastname"),
            get(result, "createdBy.email"),
            firstnames,
            lastnames,
            emails,
            rewardName,
            get(result, "quantity", 0),
            get(result, "costTotal.amount", 0),
            purchaseDate
        ];
    });
    var csv = Papa.unparse({ fields: headers, data: data });
    makeCSV(csv, "reward-log.csv");
    adminTracking.downloadRewardLog();
};
export default generateCSV;
